import actionCreatorFactory from "typescript-fsa";
import { CommonAsyncType } from "../../core/types";
import { BlogListRequestBody, BlogListResponse } from "../../core/api/requests/blog/list/types";
import { BlogDetailRequestBody, BlogDetailResponse } from "../../core/api/requests/blog/detail/types";
import { BlogCreateRequestBody, BlogCreateResponse } from "../../core/api/requests/blog/create/types";
import { BlogEditRequestBody, BlogEditResponse } from "../../core/api/requests/blog/edit/types";
import { BlogDeleteRequestBody, BlogDeleteResponse } from "../../core/api/requests/blog/delete/types";

const actionCreator = actionCreatorFactory("@@Blog");

export const blogActions = {
    fetchBlogs: actionCreator.async<CommonAsyncType<BlogListResponse> & BlogListRequestBody, BlogListResponse>("FETCH_BLOGS"),
    getBlogDetails: actionCreator.async<CommonAsyncType<BlogDetailResponse> & BlogDetailRequestBody, BlogDetailResponse>("GET_BLOG_DETAILS"),
    createNewBlog: actionCreator.async<CommonAsyncType<BlogCreateResponse> & BlogCreateRequestBody, BlogCreateResponse>("CREATE_NEW_BLOG"),
    updateBlog: actionCreator.async<CommonAsyncType<BlogEditResponse> & BlogEditRequestBody & { id: string }, BlogEditResponse>("UPDATE_BLOG"),
    deleteBlog: actionCreator.async<CommonAsyncType<BlogDeleteResponse> & BlogDeleteRequestBody & { id: string }, {}>("DELETE_BLOG"),
    resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
}